import Menu from "../../../components/menu/menu.jsx";
import Busca from "../../../components/busca/busca.jsx";
import MyDataTable from "../../../components/mydatatable/mydatatable.jsx";
import { confirmAlert } from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import ClienteCad from "../clientescad/clientescad.jsx";
import { useCallback, useEffect, useState } from "react";
import writeXlsxFile from "write-excel-file/browser";
import api from "../../../services/api.js";
import Filtrossindicalizados from "../../../components/filtrossindicalizados/filtrossindicalizados.jsx";
import "./cliente.css";
import ClientesPDF from "../../../components/relatorios/clientes/lista/rel_listacliente.jsx";

const initialState = {
    unidade: '',
    curso: '',
    situacao: '',
    aniversariantes: '',
    inifiliacao: '',
    fimfiliacao: '',
    tipocontribuicao: '',
    cpf: '',
    departamento: '',
};

const normalizeText = (value) =>
    typeof value === "string" ? value.trim().toUpperCase() : "";

const parseLegacyDate = (value) => {
    if (!value || typeof value !== "string") {
        return null;
    }

    if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
        const [day, month, year] = value.split('/').map(Number);
        const parsed = new Date(year, month - 1, day);
        return Number.isNaN(parsed.getTime()) ? null : parsed;
    }

    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const formatarData = (data) => {
    const parsed = parseLegacyDate(data);
    if (!parsed) {
        return "";
    }

    const dia = String(parsed.getDate()).padStart(2, '0');
    const mes = String(parsed.getMonth() + 1).padStart(2, '0');
    const ano = parsed.getFullYear();
    return `${dia}/${mes}/${ano}`;
};

const formatTelefone = (telefone) => {
    if (!telefone) {
        return "";
    }
    return telefone.replace(/\D/g, '').replace(/(\d{1})(\d{4})(\d{4})/, '$1 $2-$3');
};

const formatDdd = (ddd) => {
    if (ddd && ddd.length >= 2) {
        return ddd.substring(ddd.length - 2);
    }
    return ddd;
};

const formatCNPJ = (cnpj = "") => {
    if (!cnpj) {
        return "";
    }

    if (cnpj.length <= 11) {
        return cnpj.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }

    return cnpj.replace(/\D/g, '').replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
};

const mergeClientesESocios = (clientes, socios) => {
    const socioByClient = new Map();

    socios.forEach((socio) => {
        const clientCode = Number(socio.CDCLI || socio.cdcli || 0);
        if (!clientCode || socioByClient.has(clientCode)) {
            return;
        }
        socioByClient.set(clientCode, socio);
    });

    return clientes.map((cliente) => {
        const socio = socioByClient.get(Number(cliente.cdcli)) || {};
        return {
            ...cliente,
            ...socio,
            matricula: socio.MATRICULA || socio.matricula || '',
            unidade: socio.UNIDADE || socio.unidade || '',
            curso: socio.CURSO || socio.curso || '',
            situacao: socio.SITUACAO || socio.situacao || '',
            departamento: socio.DEPARTAMENTO || socio.departamento || '',
            opcontrib: socio.OPCONTRIB || socio.opcontrib || '',
            DTFILICAO: socio.DTFILICAO || socio.dtfilicao || '',
        };
    });
};

const matchesDateRange = (value, start, end) => {
    const parsedValue = parseLegacyDate(value);
    if (!parsedValue) {
        return false;
    }

    const startDate = parseLegacyDate(start);
    const endDate = parseLegacyDate(end);

    if (startDate && parsedValue < startDate) {
        return false;
    }

    if (endDate && parsedValue > endDate) {
        return false;
    }

    return true;
};

const matchesBirthdayFilter = (rowDate, mode) => {
    const parsed = parseLegacyDate(rowDate);
    if (!parsed || !mode) {
        return true;
    }

    const today = new Date();

    if (mode === "dodia") {
        return parsed.getDate() === today.getDate() && parsed.getMonth() === today.getMonth();
    }

    if (mode === "domes") {
        return parsed.getMonth() === today.getMonth();
    }

    if (mode === "dasemana") {
        const weekStart = new Date(today);
        weekStart.setHours(0, 0, 0, 0);
        weekStart.setDate(today.getDate() - today.getDay());

        const weekEnd = new Date(weekStart);
        weekEnd.setDate(weekStart.getDate() + 6);

        const currentYearBirthday = new Date(
            today.getFullYear(),
            parsed.getMonth(),
            parsed.getDate()
        );

        return currentYearBirthday >= weekStart && currentYearBirthday <= weekEnd;
    }

    return true;
};

function Clientes() {
    const [isMenuVisible, setIsMenuVisible] = useState(true);
    const [status, setStatus] = useState("");
    const [qtd_reg_pagina, setQtdRegPagina] = useState(10);
    const [dados, setDados] = useState([]);
    const [total_registros, setTotalRegistros] = useState(0);
    const [buscaTexto, setBuscaTexto] = useState("");
    const [tipoemp, setTipoemp] = useState();
    const [titulo, setTitulo] = useState();
    const [filtros, setFiltros] = useState(initialState);
    const [todosClientes, setTodosClientes] = useState([]);
    const [todosSocios, setTodosSocios] = useState([]);

    const isSindicato = tipoemp && typeof tipoemp === "string" && tipoemp.slice(0, 2) === "10";

    const handleDataChange = (updatedfiltros) => {
        setFiltros((current) => ({
            ...current,
            ...updatedfiltros,
        }));
    };

    const commonColumns = [
        {
            name: 'Codigo',
            selector: row => row.cdcli,
            sortable: true,
            width: "90px",
        },
        {
            name: 'Descricao',
            selector: row => row.decli,
            sortable: true,
            compact: true,
            width: "200px",
        },
        {
            name: 'Telefone',
            selector: row => (
                <p className="mb-1">({formatDdd(row.dddcli)}) {formatTelefone(row.fonecli)}</p>
            ),
            sortable: true,
            width: "160px",
        },
        {
            name: 'Cidade',
            selector: row => row.cidcli,
            sortable: true,
            width: "120px",
        },
        {
            name: 'Bairro',
            selector: row => row.baicli,
            sortable: true,
            width: "170px",
            compact: true,
        },
        {
            cell: (row) => (
                <div className="right-aligned-cell">
                    <button onClick={() => WhatsApp(row.dddcli + row.fonecli)} className={row.fonecli ? "btn btn-success" : "btn btn-success disabled"}>
                        <i className="bi bi-whatsapp"></i>
                    </button>
                    <button onClick={() => Editar(row.cdcli)} className="btn btn-primary ms-1">
                        <i className="bi bi-pencil-square"></i>
                    </button>
                    <button onClick={() => Excluir(row.cdcli)} className="btn btn-danger ms-1">
                        <i className="bi bi-trash3-fill"></i>
                    </button>
                </div>
            ),
            width: "200px",
            right: true
        }
    ];

    const commonColumns2 = [
        {
            name: 'CODIGO',
            selector: row => row.cdcli,
            sortable: true,
            width: '9%',
            style: { fontSize: "11px" },
        },
        {
            name: 'NOME',
            selector: row => row.decli,
            sortable: true,
            compact: true,
            width: '17%',
            style: { fontSize: "11px" },
        },
        {
            name: 'CPF',
            selector: row => formatCNPJ(row.cnpj_cpfcli || ''),
            sortable: true,
            compact: true,
            width: '8%',
            style: { fontSize: "11px" },
        },
        {
            name: 'SIAP',
            selector: row => row.matricula,
            sortable: true,
            compact: true,
            width: '7%',
            style: { fontSize: "11px", margin: "-1 1px" },
        },
        {
            name: 'TELEFONE',
            selector: row => (
                <p className="mb-1">({formatDdd(row.dddcli)}) {formatTelefone(row.fonecli)}</p>
            ),
            sortable: true,
            width: '11%',
            style: { fontSize: "11px" },
        },
        {
            name: 'UNIDADE',
            selector: row => row.unidade,
            sortable: true,
            compact: true,
            width: '7%',
            style: { fontSize: "11px" },
        },
        {
            name: 'CURSO',
            selector: row => row.curso,
            sortable: true,
            compact: true,
            width: '15%',
            style: { fontSize: "11px" },
        },
        filtros.aniversariantes !== '' ? {
            name: 'NASCIMENTO',
            selector: row => formatarData(row.nasctocli),
            sortable: true,
            compact: true,
            width: '10%',
            style: { fontSize: "11px", textAlign: 'center' },
        } : {
            name: 'SITUACAO',
            selector: row => (row.situacao || '').toUpperCase(),
            sortable: true,
            compact: true,
            width: '10%',
            style: { fontSize: "11px", textAlign: 'center' }
        },
        {
            name: 'Filiado',
            selector: row => (row.ativocli || '').toUpperCase(),
            sortable: true,
            compact: true,
            width: '5%',
            style: { fontSize: "11px" },
        },
        {
            cell: (row) => (
                <div className="right-aligned-cell">
                    <button onClick={() => WhatsApp(row.dddcli + row.fonecli)} className={row.fonecli ? "btn btn-success" : "btn btn-success disabled"}>
                        <i className="bi bi-whatsapp"></i>
                    </button>
                    <button onClick={() => Editar(row.cdcli)} className="btn btn-primary ms-1">
                        <i className="bi bi-pencil-square"></i>
                    </button>
                    <button onClick={() => Excluir(row.cdcli)} className="btn btn-danger ms-1">
                        <i className="bi bi-trash3-fill"></i>
                    </button>
                </div>
            ),
            width: "12%",
            right: true
        }
    ];

    const columns = isSindicato ? commonColumns2 : commonColumns;

    const toggleMenu = () => {
        setIsMenuVisible(!isMenuVisible);
    };

    const paginationOptions = {
        rowsPerPageText: 'Registros por pagina',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    function WhatsApp(fone) {
        if (fone) {
            const url = "https://web.whatsapp.com/send?phone=55" + fone;
            window.open(url, "_blank", "noreferrer");
        }
    }

    const aplicarFiltros = useCallback((clientes, socios, currentStatus, currentBusca, currentFiltros) => {
        let rows = mergeClientesESocios(clientes, socios);
        const searchTerm = normalizeText(currentBusca);
        const cpfTerm = (currentFiltros.cpf || '').replace(/\D/g, '');

        rows = rows.filter((row) => {
            if (searchTerm) {
                const searchFields = [row.decli, row.fantcli, row.cidcli, row.baicli]
                    .map(normalizeText);

                if (!searchFields.some((value) => value.includes(searchTerm))) {
                    return false;
                }
            }

            if (currentStatus === "Ativos" && normalizeText(row.ativocli) !== "S") {
                return false;
            }

            if (currentStatus === "Inativos" && normalizeText(row.ativocli) === "S") {
                return false;
            }

            if (currentFiltros.unidade && normalizeText(row.unidade) !== normalizeText(currentFiltros.unidade)) {
                return false;
            }

            if (currentFiltros.curso && normalizeText(row.curso) !== normalizeText(currentFiltros.curso)) {
                return false;
            }

            if (currentFiltros.departamento && normalizeText(row.departamento) !== normalizeText(currentFiltros.departamento)) {
                return false;
            }

            if (currentFiltros.situacao && normalizeText(row.situacao) !== normalizeText(currentFiltros.situacao)) {
                return false;
            }

            if (currentFiltros.tipocontribuicao && normalizeText(row.opcontrib) !== normalizeText(currentFiltros.tipocontribuicao)) {
                return false;
            }

            if (cpfTerm && !(row.cnpj_cpfcli || '').replace(/\D/g, '').includes(cpfTerm)) {
                return false;
            }

            if (currentFiltros.aniversariantes && !matchesBirthdayFilter(row.nasctocli, currentFiltros.aniversariantes)) {
                return false;
            }

            if ((currentFiltros.inifiliacao || currentFiltros.fimfiliacao) && !matchesDateRange(row.DTFILICAO, currentFiltros.inifiliacao, currentFiltros.fimfiliacao)) {
                return false;
            }

            return true;
        });

        rows.sort((left, right) => normalizeText(left.decli).localeCompare(normalizeText(right.decli), 'pt-BR'));
        return rows;
    }, []);

    const iniciarRequisicao = useCallback(async (user, currentStatus, decli, page, pageSize, currentFiltros) => {
        try {
            const filteredRows = aplicarFiltros(
                todosClientes,
                todosSocios,
                currentStatus,
                decli,
                currentFiltros
            );

            const currentPage = Math.max(1, Number(page) || 1);
            const currentPageSize = Math.max(1, Number(pageSize) || qtd_reg_pagina);
            const start = (currentPage - 1) * currentPageSize;

            setTotalRegistros(filteredRows.length);
            setDados(filteredRows.slice(start, start + currentPageSize));
        } catch (error) {
            setTotalRegistros(0);
            setDados([]);
            alert("Erro ao carregar clientes...");
        }
    }, [aplicarFiltros, qtd_reg_pagina, todosClientes, todosSocios]);

    const carregarDadosBase = useCallback(async () => {
        try {
            const [clientesResponse, sociosResponse] = await Promise.all([
                api.get("/t_cli", {
                    params: {
                        user: localStorage.getItem("user"),
                    }
                }),
                api.get("/t_socio", {
                    params: {
                        user: localStorage.getItem("user"),
                    }
                })
            ]);

            setTodosClientes(clientesResponse.data?.rows || []);
            setTodosSocios(sociosResponse.data?.rows || []);
        } catch (error) {
            setTodosClientes([]);
            setTodosSocios([]);
            setDados([]);
            setTotalRegistros(0);
            alert("Erro ao carregar clientes...");
        }
    }, []);

    function Excluir(id) {
        confirmAlert({
            title: 'Exclusao',
            message: 'Confirma a exclusao do registro?',
            buttons: [
                {
                    label: 'Sim',
                    onClick: async () => {
                        try {
                            await api.delete("/t_cli/" + id, {
                                params: {
                                    user: localStorage.getItem("user"),
                                }
                            });

                            await carregarDadosBase();
                            alert('Registro: ' + id + ' excluido com sucesso!');
                        } catch (err) {
                            alert("Erro ao excluir cliente.");
                        }
                    }
                },
                {
                    label: 'Nao',
                    onClick: () => { }
                }
            ]
        });
    }

    function Editar(id) {
        const event = new CustomEvent("openSidebar", {
            detail: {
                operacao: "edit",
                codcli: id
            }
        });

        window.dispatchEvent(event);
    }

    function Incluir() {
        const event = new CustomEvent("openSidebar", {
            detail: {
                operacao: "Incluir"
            }
        });

        window.dispatchEvent(event);
    }

    function ChangeStatus(e) {
        setStatus(e.target.value);
    }

    function ChangePerRows(newQtd) {
        setQtdRegPagina(newQtd);
    }

    function ChangePage(page) {
        iniciarRequisicao(
            localStorage.getItem("user"),
            status === "" ? "Todos" : status,
            buscaTexto,
            page,
            qtd_reg_pagina,
            filtros
        );
    }

    function handleBusca(texto) {
        setBuscaTexto(texto);
    }

    useEffect(() => {
        carregarDadosBase();
    }, [carregarDadosBase]);

    useEffect(() => {
        iniciarRequisicao(
            localStorage.getItem("user"),
            status === "" ? "Todos" : status,
            buscaTexto,
            1,
            qtd_reg_pagina,
            filtros
        );
    }, [buscaTexto, filtros, iniciarRequisicao, qtd_reg_pagina, status, todosClientes, todosSocios]);

    useEffect(() => {
        setTipoemp(localStorage.getItem("tipoemp"));
    }, []);

    useEffect(() => {
        if (tipoemp && typeof tipoemp === "string") {
            setTitulo(tipoemp.slice(0, 2) === '10' ? "Sindicalizados" : "Clientes");
        }
    }, [tipoemp]);

    useEffect(() => {
        const refreshHandler = () => {
            carregarDadosBase();
        };

        window.addEventListener("clientesAtualizados", refreshHandler);
        return () => window.removeEventListener("clientesAtualizados", refreshHandler);
    }, [carregarDadosBase]);

    const exportToExcel = async () => {
        const columnsToExport = dados.map((item) => ({
            Codigo: item.cdcli,
            Nome: item.decli,
            DDD: item.dddcli,
            Fone: item.fonecli,
            ST: item.ativocli === 'S' ? 'ATIVO' : 'INATIVO',
            Admissao: formatarData(item.DTFILICAO),
            Situacao: item.situacao || '',
            Nascimento: formatarData(item.nasctocli),
            Curso: item.curso,
        }));

        const sheetData = [
            [
                { value: "Codigo", fontWeight: "bold" },
                { value: "Nome", fontWeight: "bold" },
                { value: "DDD", fontWeight: "bold" },
                { value: "Fone", fontWeight: "bold" },
                { value: "ST", fontWeight: "bold" },
                { value: "Admissao", fontWeight: "bold" },
                { value: "Situacao", fontWeight: "bold" },
                { value: "Nascimento", fontWeight: "bold" },
                { value: "Curso", fontWeight: "bold" },
            ],
            ...columnsToExport.map((row) => ([
                row.Codigo,
                row.Nome,
                row.DDD,
                row.Fone,
                row.ST,
                row.Admissao,
                row.Situacao,
                row.Nascimento,
                row.Curso,
            ])),
        ];

        await writeXlsxFile(sheetData, {
            columns: [
                { width: 12 },
                { width: 35 },
                { width: 10 },
                { width: 18 },
                { width: 12 },
                { width: 14 },
                { width: 18 },
                { width: 14 },
                { width: 28 },
            ],
            sheet: "Clientes",
        }).toFile("clientes.xlsx");
    };

    return (
        <div className={isMenuVisible ? "app-container" : "app-container-local"} >
            {isMenuVisible && (
                <div className="menu-visible col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                    <Menu page="empresas" />
                </div>
            )}

            <div className="row flex-nowrap">
                <ClienteCad />
                <div className="container-fluid">
                    <div className="row flex-nowrap">
                        <div className={`col py-3 me-4 ${isMenuVisible ? '' : 'expand-content'}`}>
                            <div className="mb-5">
                                <Busca texto="Digite o nome do cliente" onSearch={handleBusca} onToggleMenu={toggleMenu} />
                            </div>

                            <div className="bg-white p-4 rounded-4 border">
                                <div className="d-flex justify-content-between mb-3" >
                                    <div className="d-inline-flex">
                                        <h2>{titulo}</h2>

                                        <div className="form-control ms-4">
                                            <select name="status" id="status" onChange={ChangeStatus}>
                                                <option value="Todos">Todos</option>
                                                <option value="Ativos">Ativos</option>
                                                <option value="Inativos">Inativos</option>
                                            </select>
                                        </div>
                                    </div>

                                    <button onClick={Incluir} className="btn btn-primary ms-4"><i className="bi bi-plus-lg me-2"></i>Novo</button>
                                </div>

                                <div>
                                    <Filtrossindicalizados
                                        filtros={filtros}
                                        onDataChange={handleDataChange}
                                        iniciarRequisicao={iniciarRequisicao}
                                        initialState={initialState}
                                        qtd_reg_pagina={qtd_reg_pagina}
                                    />
                                    <br />
                                </div>

                                <div className="container-tabela">
                                    <MyDataTable
                                        columns={columns}
                                        data={dados}
                                        pagination={true}
                                        paginationComponentOptions={paginationOptions}
                                        noDataComponent={<p className="no-data-found">Nenhum registro encontrado</p>}
                                        paginationServer={true}
                                        paginationTotalRows={total_registros}
                                        onChangeRowsPerPage={ChangePerRows}
                                        onChangePage={ChangePage}
                                        responsive={true}
                                    />
                                </div>

                                <button onClick={exportToExcel} className="btn btn-success btn-cli">
                                    <i className="bi bi-file-excel me-2"></i>Gerar Excel
                                </button>
                                <button onClick={() => ClientesPDF(dados, filtros)} className="btn btn-danger btn-cli">
                                    <i className="fa-regular fa-file-pdf me-2"></i>Gerar PDF
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Clientes;
